import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './asset/css/style.css';
import './asset/css/responsive.css';

import { BrowserRouter } from 'react-router-dom';

// Owl Carousel
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

// AOS Animation
import AOS from 'aos';
import 'aos/dist/aos.css'; 

// Google Font
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/inter/400-italic.css"; // Specify weight and style

// Cookie
import CookieConsent from "react-cookie-consent";

AOS.init();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    // <React.StrictMode>
       <BrowserRouter>
        {/* npm i react-cookie-consent */}
        <CookieConsent
        location="bottom"
        buttonText="I Accept"
        cookieName="myAwesomeCookieName2"
        enableDeclineButton
        buttonWrapperClasses="button-align"
        declineButtonText="Reject"
        buttonClasses="cookie-accept-button"
        declineButtonClasses="cookie-decline-button"
        declineButtonStyle={{
            padding: '10px 40px',
            borderRadius: '15px',
            backgroundColor: '#000',
            border: '1px solid transparent',
            color: '#fff',
            fontSize: '13px',
            outline: 'none',
            fontWeight: '500',
        }}
        buttonStyle={{
            padding: '10px 40px',
            borderRadius: '15px',
            backgroundColor: '#BC1823',
            border: '1px solid transparent',
            color: '#fff',
            fontSize: '13px',
            outline: 'none',
            fontWeight: '500',
        }}
        
        style={{ background: "#fff", textAlign: 'center' }}
        expires={150}
        buttonOrder={['button','declineButton']}
        
        >
        <div className="cookie-shap">
            <img src="../assets/images/meow.svg" alt="" />
        </div>
        <div className="cookie-shap-1">
            <img src="../assets/images/sicon-4.svg" alt="" />
        </div>
        <div className="cookie-shap-2">
            <img src="../assets/images/sicon-11.svg" alt="" />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
            <img src="../assets/images/cookie-img.svg" alt="Cookie" className='cookie-img' />
        </div>
        <h5 className='coolies-text'>Our website uses cookies</h5>
        <p className='mb-0 coolies-descrip'>Our website use cookies. By continuing, we assume your permission to deploy cookies as detailed in our Privacy Policy.</p>
        </CookieConsent>

        <App />

        </BrowserRouter>
    // </React.StrictMode>
);

